import { SET_PENDING_AUTOSCROLL, LOCK_SCROLL, UNLOCK_SCROLL } from 'reducers/actions-types';
import scrollbarWidth from 'util/dom/scrollbar-width';

export default function scrollReducer(state = {
    mustAutoscroll: false,
    isLocked: false,
    scrollbarWidth: scrollbarWidth(),
}, { type, mustAutoscroll }) {
    switch (type) {
        case SET_PENDING_AUTOSCROLL:
            return Object.assign({}, state, { mustAutoscroll });
        case LOCK_SCROLL:
        case UNLOCK_SCROLL:
            return Object.assign({}, state, {
                isLocked: type === LOCK_SCROLL,
            });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./mcart/assets/src/js/app/reducers/modules/scroll/index.js